module.exports = __webpack_public_path__ + "static/media/mobile-active.b2116091.svg";